export const SUCCESS_FLAG_TEST_ID = 'jira-issue-create.modal.create-form.success-flag';

export const CMP_SCRUM_FLAG = 'cmp-scrum-flag' as const;
export const CMP_KANBAN_FLAG = 'cmp-kanban-flag' as const;
export const DEFAULT_SUCCESS_FLAG = 'default-success-flag' as const;
